import React from 'react';
import { processSteps } from '../data/mock';
import { MessageCircle, FileText, Wrench, Zap } from 'lucide-react';

const iconMap = {
  'message-circle': MessageCircle,
  'file-text': FileText,
  'wrench': Wrench,
  'zap': Zap
};

const ProcessSection = () => {
  return (
    <section id="ablauf" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-sun-blue/10 text-sun-blue rounded-full text-sm font-semibold mb-4">
            Der Ablauf
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            In 4 Schritten zu
            <span className="text-sun-orange"> Ihrer Solaranlage</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Von der ersten Beratung bis zur Inbetriebnahme – wir begleiten Sie 
            durch den gesamten Prozess.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-28 left-[12%] right-[12%] h-1 bg-gradient-to-r from-sun-orange via-sun-blue via-amber-500 to-green-500 rounded-full" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              const colors = [
                { bg: 'bg-sun-orange', light: 'bg-sun-orange/10', text: 'text-sun-orange', shadow: 'shadow-sun-orange/30' },
                { bg: 'bg-sun-blue', light: 'bg-sun-blue/10', text: 'text-sun-blue', shadow: 'shadow-sun-blue/30' },
                { bg: 'bg-amber-500', light: 'bg-amber-100', text: 'text-amber-500', shadow: 'shadow-amber-500/30' },
                { bg: 'bg-green-500', light: 'bg-green-100', text: 'text-green-500', shadow: 'shadow-green-500/30' }
              ][index];
              
              return (
                <div key={index} className="relative">
                  <div className="bg-white rounded-3xl p-8 shadow-lg border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full">
                    {/* Step Number */}
                    <div className={`absolute -top-5 left-8 w-10 h-10 ${colors.bg} rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-lg ${colors.shadow}`}>
                      {step.step}
                    </div>
                    
                    {/* Icon */}
                    <div className={`w-20 h-20 ${colors.light} rounded-2xl flex items-center justify-center mb-6 mt-4`}>
                      <IconComponent className={`w-10 h-10 ${colors.text}`} />
                    </div>
                    
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
